module.exports = __webpack_public_path__ + "img/product_3.fede3aa.webp";